import { axiosInstance, parseResult } from "./CommonApi";

//모바일 알람 설정 조회
export const getFireFightingObjectMobileAlarmSetting = async (id) => {
    const params = { id: id };
    const response = await axiosInstance.get(`/mobile/firefighting-object/alarm-setting/${id}/`, { params });
    return parseResult(response);
};

//모바일 알람 설정 업데이트
export const updateFireFightingObjectMobileAlarmSetting = async (id, requestBody) => {
    const params = { id: id };
    const response = await axiosInstance.put(`/mobile/firefighting-object/alarm-setting/${id}/`,
        requestBody,
        {
            params: params,
            headers: { "Content-Type": "application/json" },
        });
    return parseResult(response);
};